module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box-preview-header clearfix"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('div', {
    staticClass: "tab-item active"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('general.labels.editing')) + " " + _vm._s(_vm.$t('general.labels.step')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tab-item",
    staticStyle: {
      "text-align": "left",
      "text-transform": "none"
    }
  }, [_c('step-select')], 1)]), _vm._v(" "), _c('device-buttons')], 1), _vm._v(" "), _c('div', {
    staticClass: "box-container",
    class: 'box-' + _vm.boxFormat + ' box-device-' + _vm.canvasPreviewDevice
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-preview-content"
  }, [_c('div', {
    class: 'kbx-modal is-open kbx-modal-type__' + _vm.boxFormat
  }, [_c('a', {
    staticClass: "kbx-modal-close",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kbx-container",
    style: (_vm.stepStyle('general'))
  }, [_c('step'), _vm._v(" "), _c('highlight')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-preview-url-container"
  }, [_c('input', {
    staticClass: "box-preview-url-field",
    attrs: {
      "type": "text",
      "value": "http://klickpages.com.br",
      "disabled": ""
    }
  })])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-37384079!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/Main.vue
 ** module id = 802
 ** module chunks = 1
 **/